import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement> & { size?: number }

const base = (size: number, props: IconProps) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
  focusable: false,
  ...props,
})

export function ArrowUpRight({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M7 17 17 7M8 7h9v9" />
    </svg>
  )
}
export function ArrowRight({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  )
}
export function ArrowLeft({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M19 12H5M11 6l-6 6 6 6" />
    </svg>
  )
}
export function Check({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="m5 12 4.5 4.5L19 7" />
    </svg>
  )
}
export function ChevronDown({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="m6 9 6 6 6-6" />
    </svg>
  )
}
export function ChevronUp({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="m6 15 6-6 6 6" />
    </svg>
  )
}
export function ChevronLeft({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="m15 6-6 6 6 6" />
    </svg>
  )
}
export function ChevronRight({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="m9 6 6 6-6 6" />
    </svg>
  )
}
export function Calendar({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <rect x="3.5" y="5" width="17" height="15.5" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
    </svg>
  )
}
export function Plus({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  )
}
export function X({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M6 6l12 12M18 6 6 18" />
    </svg>
  )
}
export function Info({ size = 16, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8h.01" />
    </svg>
  )
}
export function Alert({ size = 16, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M12 4 2.5 20h19L12 4ZM12 10v4M12 17h.01" />
    </svg>
  )
}
export function Clock({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  )
}
export function Lock({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <rect x="5" y="11" width="14" height="10" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  )
}
export function Eye({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  )
}
export function Copy({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <rect x="9" y="9" width="11" height="11" />
      <path d="M5 15V4h11" />
    </svg>
  )
}
export function Dot({ size = 8, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 8 8" aria-hidden="true" focusable="false" {...props}>
      <circle cx="4" cy="4" r="4" fill="currentColor" />
    </svg>
  )
}

export function Pencil({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M4 20h4L19 9l-4-4L4 16v4z" />
      <path d="M13.5 6.5l4 4" />
    </svg>
  )
}

export function Undo({ size = 14, ...props }: IconProps) {
  return (
    <svg {...base(size, props)}>
      <path d="M9 14L4 9l5-5" />
      <path d="M4 9h10.5a5.5 5.5 0 010 11H11" />
    </svg>
  )
}
